import React from 'react';
import './preloader.css';
export function Preloader() {
    return (React.createElement("div", { className: "loader" },
        React.createElement("span", { className: "ball" }),
        React.createElement("span", { className: "ball2" }),
        React.createElement("ul", null,
            React.createElement("li", null),
            React.createElement("li", null),
            React.createElement("li", null),
            React.createElement("li", null),
            React.createElement("li", null))));
}
